import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}
  handleError(error: any): void {
    // Check if this error was already handled by the interceptor
    if (error.handledByInterceptor) {
      console.error('Error already handled by interceptor:', error);
      return;
    }

    const toastr = this.injector.get(ToastrService);

    let errorMessage = 'An unexpected error occurred';

    if (error.name && error.message) {
      errorMessage = `${error.name}: ${error.message}`;
    }

    console.error('Global error handler:', error);
    toastr.error(errorMessage, 'Application Error');
  }
}
